import React from 'react';
import Link from 'next/link';
import round from 'lodash/round';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import SvgFire from './SvgFire';
import { SalaryRankType } from '@/types/job-ranking';
import { SALARY_RANK } from '@/constants/job-ranking';
import {
  JOB_RANKING_PAGE_ROUTER_PATH,
  JOB_TITLE_PAGE_ROUTER_PATH,
} from '@/constants/router-path';
import { renameL1Name } from '@/utils/job-ranking';
import { getJobTitleRankData } from '@/api/tanzhi';

const RANK_COUNT = 5;

const HighSalaryRank = (props: { id: string; name: string; city?: string }) => {
  const { id, name, city } = props;
  const [data, setData] = React.useState<SalaryRankType[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    getJobTitleRankData(id, city || '')
      .then((res) => {
        if (res.status == 200) {
          setData(res.data[SALARY_RANK].slice(0, RANK_COUNT));
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 rounded-lg bg-web-grey-400 my-10">
      <div className="flex items-center">
        <SvgFire className="shrink-0" />
        <span className="ml-2 text-xl font-semibold">{`${renameL1Name(
          id,
          name,
        )}高薪榜单`}</span>
      </div>
      <ul className="list-none !ml-0 text-sm font-semibold">
        {loading
          ? Array.from({ length: RANK_COUNT }).map((_, index) => (
              <li key={index} className="mt-6">
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={24}
                  className="!mt-6"
                />
              </li>
            ))
          : data.map(({ avg, job_title_name, job_title_id }, index) => (
              <li key={index} className="mt-6 flex">
                <span
                  className={`block w-6 h-6 rounded-full shrink-0 flex items-center justify-center ${index === 0 ? 'text-web-earth-600 bg-web-earth-200' : index === 1 ? 'text-web-neutral-800 bg-web-neutral-200' : index === 2 ? 'text-web-orange-600 bg-web-orange-200' : 'text-web-blue-700 bg-web-blue-200'}`}
                >
                  {index + 1}
                </span>
                <Link
                  href={JOB_TITLE_PAGE_ROUTER_PATH + job_title_id}
                  title={job_title_name}
                  className="block ml-2 line-clamp-1 hover:underline"
                >
                  {job_title_name}
                </Link>
                <span className="shrink-0 ml-auto">{`¥${round(avg, -2)}`}</span>
              </li>
            ))}
      </ul>
      <div className="mt-6 pt-3.5 border-t border-web-tertiary text-center">
        <Button
          variant="contained"
          className="!w-[220px] !h-[42px] !bg-white !text-primary hover:!bg-web-neutral-300"
          LinkComponent={Link}
          href={`${JOB_RANKING_PAGE_ROUTER_PATH}${
            city ? `${city}_` : ''
          }${id}/`}
          target="_blank"
        >
          查看更多
        </Button>
      </div>
    </div>
  );
};

export default HighSalaryRank;
